<template>
  <div>
    <h1 class="p-ml-3 p-mb-2">{{ isAdmin ? `${company.companyname} - `: '' }}{{ title }}</h1>
    <DataTable
      v-if="employees"
      :value="employees"
      :loading="loading"
      @row-select="updateSelected"
      @row-unselect="updateSelected"
      :filters="filters" 
      :selection.sync="selected" 
    >
      <template v-if="add" #header>
        <div class="p-d-flex p-jc-end">
          <Button label="Legg til" icon="pi pi-plus" @click="addUser()" />
        </div>
      </template>
      <Column v-if="select" selectionMode="multiple" headerStyle="width: 3em"></Column>
      <Column field="name" header="Navn" filterMatchMode="contains">
        <template #filter>
          <InputText 
            type="text" 
            v-model="filters['name']" 
            class="p-column-filter" 
            placeholder="Søk på navn"
          ></InputText>
        </template>
        <template v-if="link" #body="slotProps">
          <p> 
            <router-link :to="`/employee/${slotProps.data.id}`">{{ slotProps.data.name }}</router-link>
          </p>
        </template>
      </Column>
      
      <Column field="Email" header="E-post" filterMatchMode="contains">
        <template #body="slotProps">
              <p>
                <a :href="`mailto:${slotProps.data.Email}`">{{ slotProps.data.Email }}</a>
              </p> 
        </template>
        <template #filter>
          <InputText 
            type="text" 
            v-model="filters['Email']" 
            class="p-column-filter" 
            placeholder="Søk på E-post"
          ></InputText>
        </template>
      </Column>
      <Column field="phone" header="Telefon"></Column>
      <Column v-if="options">
        <template #body="slotProps">
          <div class="p-d-flex p-jc-end">
            <Button label="Prosjekter" class="p-button-primary p-mr-2" @click="seeEmployee(slotProps.data)" />
            <template v-if="isSuperAdmin">
              <Button :disabled="isCurrentUser(slotProps.data)" label="Deaktiver" class="p-button-secondary" @click="remove(slotProps.data)" />
              <template v-if="isAdmin && user.id !== slotProps.data.id">
                <Button 
                  v-if="isUserAdmin(slotProps.data.level)" 
                  label="Admin" 
                  class="p-ml-2 p-button-danger" 
                  icon="pi pi-minus" 
                  :disabled="isCurrentUser(slotProps.data)"
                  @click="changeAdminLevel(slotProps.data, 'companyUser')" 
                ></Button>
                <Button 
                  v-else 
                  label="Admin" 
                  class="p-button-secondary p-ml-2" 
                  icon="pi pi-plus" 
                  :disabled="isCurrentUser(slotProps.data)"
                  @click="changeAdminLevel(slotProps.data, 'companyAdmin')" 
                ></Button>
              </template>
            </template>

          </div>
        </template>
      </Column>
      <template #footer>
        <div v-if="add" class="p-d-flex p-jc-end">
          <Button label="Legg til" icon="pi pi-plus" @click="addUser()" />
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
name: 'employeeList',

components: {
  DataTable,
  Column,
}, 

props: {
  select: {
    type: Boolean, 
    default: false
  },
  
  title: {
    type: String,
    default: 'Ansatte'
  },
  
  options: {
    type: Boolean,
    default: false,
  },
  add: {
    type: Boolean, 
    default: false
  }, 
  link: {
    type: Boolean,
    default: false
  }
},

data(){
  return {
    filters: {},
    selected: [],
    loading: true,
  }
},

mounted(){
  this.$store.dispatch('employees/inspect', {id: this.company.organizationnumber, type: 'company'}).then(() => {
    this.loading = false 
  })
},

methods: {
  isCurrentUser(user){
    return this.user.id == user.id
  },
  addUser(){
    this.$router.push({name: 'employeeAdd'})
  },
  isUserAdmin(level){
    switch(level){
      case'companyUser': return false 
      case 'companyAdmin': return true
      case 'glorUser' : return true
      case 'glorDisposal' : return true
      default: return false
    }
  },
  changeAdminLevel(employee, level){
    this.$store.dispatch('employees/update', {employee, data: {level: level}}).then(() => {
      this.$toast.add({
        severity:'success',
        summary: 'Rettigheter endret',
        detail: `Rettigheten til ${employee.name} er endret til bedrifts ${level == 'companyUser' ? 'bruker' : 'administrator'}`,
        life: 5000,
      })
    })
  },
  remove(employee){
    this.$confirm.require({
        message: `Er du sikker på at du vil deaktivere ${employee.name}?`,
        header: 'Deaktiver bruker',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.$store.dispatch('employees/update', {employee, data: {active: false}})       
            
        },
            
        reject: () => {
            //callback to execute when user rejects the action
        }
    });
    
  },

  updateSelected(){
    this.$emit('update', this.selected)
  },
  seeEmployee(employee){
    this.$router.push({name: 'employee', params: {id: employee.id}})
  }
},


computed:{
  user(){
    return this.$store.getters["user/get"]
  },
  company(){
    return this.$store.getters['companies/current']  
  },
  
  isSuperAdmin(){
    return this.$store.getters["user/superAdmin"]
  },
  
  employees(){ 
    return this.$store.getters["employees/inspect"]
  },
  
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  }
}
}
</script>